import { ARCHIVED_COLUMN, LIST_WIDTH } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Name',
    field: 'typeName',
    width: LIST_WIDTH.default,
  },
];
